var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("AlternativeEditorDialog", {
        attrs: { viewModel: _vm.alternativeEditorDialog },
      }),
      _vm._v(" "),
      _c("EmailSender", {
        attrs: { viewModel: _vm.emailSender },
        on: { "form-submit": _vm.handleEmailSenderFormSubmit },
      }),
      _vm._v(" "),
      _c("NoteLogger", {
        attrs: { viewModel: _vm.noteLogger },
        on: { "create-note": _vm.handleCreateNoteCommand },
      }),
      _vm._v(" "),
      _c("LogsBrowser", { attrs: { viewModel: _vm.logsBrowser } }),
      _vm._v(" "),
      _c("AlternativeRelationshipsDialog", {
        attrs: { viewModel: _vm.alternativeRelationshipsDialog },
        on: {
          "load-alternatives": _vm.loadAlternativesForDependencyDialog,
          "unlink-dependent": _vm.handleUnlinkDependentAlternativeCommand,
          "unlink-foundation": _vm.handleUnlinkFoundationAlternativeCommand,
          "link-foundation": _vm.handleLinkFoundationAlternativeCommand,
          "link-dependent": _vm.handleLinkDependentAlternativeCommand,
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.startDateMonthPicker },
        on: { "update-date": _vm.handleUpdateAlternativeStartDateCommand },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.commitmentDateMonthPicker },
        on: { "update-date": _vm.handleUpdateAlternativeCommitmentDateCommand },
      }),
      _vm._v(" "),
      _vm.isWorkspaceMember
        ? _c("PortfolioOrDecisionNavigation", {
            attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
          })
        : _vm.isProjectOwner
        ? _c("Navigation")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "h1",
                {
                  staticStyle: {
                    "font-size": "2em",
                    "font-weight": "300",
                    color: "#33475b",
                    margin: "0",
                  },
                },
                [_vm._v(_vm._s(_vm.alternativeName))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right align-self-end" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/q/project/summary/${_vm.workspaceId}/${_vm.projectId}/${_vm.alternativeId}`,
                      expression:
                        "`/#/q/project/summary/${workspaceId}/${projectId}/${alternativeId}`",
                    },
                  ],
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                },
                [_vm._v("Business case")]
              ),
              _vm._v(" "),
              _vm.isWorkspaceMember
                ? _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { type: "button", disabled: _vm.rm == null },
                        on: {
                          click: function ($event) {
                            return _vm.showAlternativeEditor(null)
                          },
                        },
                      },
                      [_vm._v("Edit")]
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu dropdown-menu-right" },
                      [
                        _c("h6", { staticClass: "dropdown-header" }, [
                          _vm._v("Custom forms"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.forms, function (f) {
                          return _c(
                            "a",
                            {
                              key: f.Id,
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.showAlternativeEditor(f.Id)
                                },
                              },
                            },
                            [_vm._v(_vm._s(f.Name))]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: {
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Edit\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu dropdown-menu-right" },
                      [
                        _c("h6", { staticClass: "dropdown-header" }, [
                          _vm._v("Custom forms"),
                        ]),
                        _vm._v(" "),
                        _vm.forms.length
                          ? _vm._l(_vm.forms, function (f) {
                              return _c(
                                "a",
                                {
                                  key: f.Id,
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showAlternativeEditor(f.Id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(f.Name) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            })
                          : _c(
                              "span",
                              { staticClass: "dropdown-item text-muted" },
                              [_vm._v("No custom forms available")]
                            ),
                      ],
                      2
                    ),
                  ]),
              _vm._v(" "),
              _vm.isWorkspaceMember
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-outline-secondary",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: {
                        href: `/#/sharing/resource/AlternativesDataShareResourceProvider/${_vm.alternativeId}`,
                      },
                    },
                    [
                      _vm._v("\n                    Share "),
                      _vm.resourceActiveShares.length
                        ? _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.resourceActiveShares.length) +
                                ")"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.rm
            ? _c(
                "div",
                { staticClass: "row", staticStyle: { height: "100vh" } },
                [
                  _c(
                    "div",
                    { staticClass: "col-xl-9 col-lg-8 col-md-7 col-sm-6" },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchPhrase,
                              expression: "searchPhrase",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "search", placeholder: "Search..." },
                          domProps: { value: _vm.searchPhrase },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.searchPhrase = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(1),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dashboard-box" },
                        [
                          _c("div", [
                            _c("strong", [_vm._v("Status")]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_vm.rm.StatusName))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3" }, [
                            _c("strong", [_vm._v("Created")]),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(_vm.rm.Created))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3" }, [
                            _c("strong", [_vm._v("Start date")]),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  on: { click: _vm.showStartDateMonthPicker },
                                },
                                [
                                  _vm.startDate
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.startDateLabel)),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "font-italic" },
                                        [_vm._v("Not defined")]
                                      ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3" }, [
                            _c("strong", [_vm._v("Commitment date")]),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-primary",
                                  on: {
                                    click: _vm.showCommitmentDateMonthPicker,
                                  },
                                },
                                [
                                  _vm.commitmentDate
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.commitmentDateLabel)),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "font-italic" },
                                        [_vm._v("Not defined")]
                                      ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.attributesBySection[""], function (attr) {
                            return _c(
                              "div",
                              { key: attr.AttributeId, staticClass: "mt-3" },
                              [
                                _c("AttributeDataView", {
                                  attrs: { readModel: attr },
                                }),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.rm.Sections, function (s) {
                        return _c("div", { key: s.Title }, [
                          s.Title
                            ? _c(
                                "div",
                                { staticClass: "dashboard-box" },
                                [
                                  _c("h4", [_vm._v(_vm._s(s.Title))]),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.attributesBySection[s.Title],
                                    function (attr) {
                                      return _c(
                                        "div",
                                        {
                                          key: attr.AttributeId,
                                          staticClass: "mt-3",
                                        },
                                        [
                                          _c("AttributeDataView", {
                                            attrs: { readModel: attr },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ])
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xl-3 col-lg-4 col-md-5 col-sm-6" },
                    [
                      _c("div", { staticClass: "dashboard-box" }, [
                        _c("h4", [_vm._v("Description")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", [
                          _vm.rm.Description
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.marked(_vm.rm.Description)
                                  ),
                                },
                              })
                            : _c(
                                "span",
                                { staticClass: "text-muted font-italic" },
                                [_vm._v("No description provided")]
                              ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dashboard-box" }, [
                        _c("h4", [_vm._v("Contacts")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._l(_vm.emailContacts, function (c) {
                              return _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center mb-2",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-sm mr-3",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEmailSender(c)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "fa fa-envelope",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("strong", [_vm._v(_vm._s(c.Name))]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(c.Email))]
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-center mt-4" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showEmailSender(null)
                                    },
                                  },
                                },
                                [_vm._v("Send email")]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dashboard-box" }, [
                        _c("h4", [_vm._v("Last activity")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        !_vm.lastLogRm
                          ? _c("div", [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(" Loading..."),
                            ])
                          : _c("div", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.lastLogRm.Title)),
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getHumanizedTimeSince(
                                          _vm.lastLogRm.Created
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(
                                    " ago\n                                by " +
                                      _vm._s(_vm.lastLogRm.Person) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-center mt-4" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    on: { click: _vm.showLogsBrowser },
                                  },
                                  [_vm._v("View logs")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    on: { click: _vm.handleShowNoteLogger },
                                  },
                                  [_vm._v("Log a note")]
                                ),
                              ]),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dashboard-box" }, [
                        _c("h3", [_vm._v("Files")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm.attachmentsRm
                          ? _c(
                              "div",
                              [
                                _vm._l(_vm.attachmentsView, function (at) {
                                  return !_vm.file
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "clearfix",
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                directives: [
                                                  {
                                                    name: "sanitizedHref",
                                                    rawName: "v-sanitizedHref",
                                                    value: at.Url,
                                                    expression: "at.Url",
                                                  },
                                                ],
                                                attrs: { target: "_blank" },
                                              },
                                              [_vm._v(_vm._s(at.Title))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dropdown pull-right",
                                              },
                                              [
                                                _vm._m(2, true),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdown-menu dropdown-menu-right",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDeleteAttachedDocumentCommand(
                                                              at
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Delete")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "text-center mt-4" },
                                  [
                                    _c("FileUploader", {
                                      on: {
                                        selected: function ($event) {
                                          _vm.file = $event
                                        },
                                        unselected: function ($event) {
                                          _vm.file = null
                                        },
                                        uploaded:
                                          _vm.handleAddAttachedDocumentCommand,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          : _c("div", [
                              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                              _vm._v(" Loading...\n                    "),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dashboard-box" }, [
                        _c("h3", [_vm._v("Dependencies")]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n                            This " +
                                _vm._s(_vm.rm.AlternativeLabel.toLowerCase()) +
                                " is a foundation for " +
                                _vm._s(_vm.rm.Dependents.length) +
                                " " +
                                _vm._s(_vm.rm.AlternativesLabel.toLowerCase()) +
                                " and is\n                            dependent on " +
                                _vm._s(_vm.rm.Foundations.length) +
                                " " +
                                _vm._s(_vm.rm.AlternativesLabel.toLowerCase()) +
                                ".\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-center mt-4" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                on: { click: _vm.showDependenciesManager },
                              },
                              [_vm._v("Manage")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass:
          "btn btn-outline-secondary dropdown-toggle dropdown-toggle-split",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Toggle Dropdown")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "pointer", attrs: { "data-toggle": "dropdown" } },
      [_c("span", { staticClass: "fa fa-bars" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }